import req from '@sportninja/common/api/request'

const scoringRequest = async (url, settings) => {
  return await req(url, settings)
}

export default scoringRequest
